export function getFileSize(file) {
    var fileSize = 0;
    
    if (!file) return fileSize;
  
    fileSize = Math.round(file.size / 1024);
    return fileSize;
  }